import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { ReactElement } from 'react';
import { SearchBarRow } from './SearchBarRow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(2, 0),
      margin: theme.spacing(2, 0),
      textAlign: 'center',
    },
    searchBox: {
      width: '100%',
    },
    text: {
      color: theme.palette.common.white,
    },
  }),
);
function Content(): ReactElement | null {
  const classes = useStyles();
  return (
    <div data-testid="knowledge-base-titleBar" className={classes.container}>
      <Typography variant="h1" data-testid="knowledge-base-title" className={classes.text}>
        What can we help you with?
      </Typography>
      <Box className={classes.searchBox} mx={3} my={2}>
        <SearchBarRow />
      </Box>
      <Typography variant="body1" className={classes.text}>
        Popular topics: Service Orders (Title Search Products), Report (Remit) Files, Pay Files
      </Typography>
    </div>
  );
}

export { Content };
